import { PostDto } from '../../../../shared/api';
import { TupleOf } from '../../../../shared/types';
import { clsx } from 'clsx';
import styles from './styles.module.scss';
import { ImageLink } from './image-link';

type Props = {
  className?: string;
  posts: TupleOf<PostDto, 7>;
};

export function Layout7(props: Props) {
  const { posts, className } = props;

  return (
    <div className={clsx(styles['layout-7'], className)}>
      <div className={styles['layout-7__col']}>
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-7__item'], styles['layout-7__item-1'])}
          post={posts[0]}
        />
      </div>
      <div className={styles['layout-7__col']}>
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-7__item'], styles['layout-7__item-2'])}
          post={posts[1]}
        />
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-7__item'], styles['layout-7__item-3'])}
          post={posts[2]}
        />
      </div>
      <div className={styles['layout-7__col']}>
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-7__item'], styles['layout-7__item-4'])}
          post={posts[3]}
        />
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-7__item'], styles['layout-7__item-5'])}
          post={posts[4]}
        />
      </div>
      <div className={styles['layout-7__col']}>
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-7__item'], styles['layout-7__item-6'])}
          post={posts[5]}
        />
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-7__item'], styles['layout-7__item-7'])}
          post={posts[6]}
        />
      </div>
    </div>
  );
}
